import React from 'react';
import { Grid, Card, CardContent, Box, Typography, Chip } from '@mui/material';
import EventNoteIcon from '@mui/icons-material/EventNote';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import FreeBreakfastIcon from '@mui/icons-material/FreeBreakfast';
import FlagIcon from '@mui/icons-material/Flag';
import { formatDuration } from '../plannerUtils';

const STATUS_META = {
  Draft: { color: 'default', label: 'Draft', accent: '#9e9e9e' },
  Submitted: { color: 'info', label: 'Submitted', accent: '#0288d1' },
  Approved: { color: 'success', label: 'Approved', accent: '#2e7d32' },
  Rejected: { color: 'error', label: 'Rejected', accent: '#d32f2f' },
};

const StatCard = ({ icon, label, value, accent }) => (
  <Grid item xs={12} sm={6} md={2.4}>
    <Card className="planner-summary-card" style={{ borderTopColor: accent }}>
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="overline" className="planner-summary-label">
            {label}
          </Typography>
          <span className="planner-summary-icon" style={{ backgroundColor: `${accent}1a`, color: accent }}>
            {icon}
          </span>
        </Box>
        <Typography variant="h5" fontWeight={700} className="planner-summary-value">
          {value}
        </Typography>
      </CardContent>
    </Card>
  </Grid>
);

const SummaryCards = ({ plannedWorkMinutes, completedWorkMinutes, remainingWorkMinutes, plannedBreakMinutes, status }) => {
  const statusMeta = STATUS_META[status] || STATUS_META.Draft;

  return (
    <Grid container spacing={2} className="planner-summary-section">
      <StatCard icon={<EventNoteIcon fontSize="small" />} label="Planned" value={formatDuration(plannedWorkMinutes)} accent="#1976d2" />
      <StatCard icon={<CheckCircleIcon fontSize="small" />} label="Completed" value={formatDuration(completedWorkMinutes)} accent="#2e7d32" />
      <StatCard icon={<HourglassEmptyIcon fontSize="small" />} label="Remaining" value={formatDuration(remainingWorkMinutes)} accent="#ed6c02" />
      <StatCard icon={<FreeBreakfastIcon fontSize="small" />} label="Break" value={formatDuration(plannedBreakMinutes)} accent="#8d6e63" />
      <Grid item xs={12} sm={6} md={2.4}>
        <Card className="planner-summary-card" style={{ borderTopColor: statusMeta.accent }}>
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="overline" className="planner-summary-label">
                Status
              </Typography>
              <span
                className="planner-summary-icon"
                style={{ backgroundColor: `${statusMeta.accent}1a`, color: statusMeta.accent }}
              >
                <FlagIcon fontSize="small" />
              </span>
            </Box>
            <Box sx={{ mt: 0.75 }}>
              <Chip label={statusMeta.label} color={statusMeta.color} size="small" sx={{ fontWeight: 600 }} />
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default SummaryCards;
